import React, { useState } from 'react';
import VideoUpload from '../../components/VideoUpload';
import DownloadsList from '../../components/DownloadsList';

function SOFArming() {
    const [downloadUrls, setDownloadUrls] = useState([]);
    const [codeTimeUrls, setCodeTimeUrls] = useState();

    const handleUploadSuccess = (urls, timeCodeUrl) => {
      console.log(urls); // Verifique se as URLs estão sendo impressas aqui
      setDownloadUrls(urls);
      setCodeTimeUrls(timeCodeUrl)
    };



    return (
        <div style={{ textAlign: 'center' }}>
            
            <div style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '10px' }}>
                <h1>SOFArming</h1>
            </div>
            <VideoUpload onUploadSuccess={handleUploadSuccess} />
            <DownloadsList downloadUrls={downloadUrls} timeCodeUrls={codeTimeUrls}/>
        </div>
    );
}

export default SOFArming;